<script>

</script>

<script setup>
const {
  component = "button",
  iconPosition = "left",
  isDisabled = false,
  isLoading = false,
  customClasses = "",
  isB2B = false
} = defineProps({
  component: { type: String, required: false },
  iconPosition: { type: String, required: false },
  isDisabled: { type: Boolean, required: false },
  isLoading: { type: Boolean, required: false },
  customClasses: { type: String, required: false },
  isB2B: { type: Boolean, required: false }
});
const emit = defineEmits(["click"]);
</script>

<template>
    <component
        :is="component"
        :disabled="isDisabled"
        type="button"
        @click="isLoading ? null : emit('click', $event)"
        class="transition ease-in-out duration-150 inline-flex items-center justify-center relative gap-2"
        :class="[iconPosition === 'right' && 'flex-row-reverse', customClasses]"
    >
        <div
            v-if="isLoading && !isB2B"
            class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
        >
            <IconLoader class="size-5 m-auto animate-spin" />
        </div>
        <slot name="icon" />
        <slot />
        <slot name="iconRight" />
    </component>
</template>
